import { toJpeg } from 'html-to-image';
import { QRCodeSVG } from 'qrcode.react';
import { useLayoutEffect, useMemo, useRef } from 'react';
import { resourceURLToFile } from 'utils/getImage';
import { useSendFileImage } from '../Toolbar/ImageUpload';

interface QRCodeImageProps {
  href: string;
  region: Conversation.Conversation['region'];
  onSend: () => void;
}

export const QRCodeImage = (props: QRCodeImageProps) => {
  const { href, region, onSend } = props;
  const ref = useRef<HTMLDivElement | null>(null);
  const sendFileImage = useSendFileImage();

  const text = useMemo(() => {
    const mapper: Record<string, string> = {
      ID: 'Silakan simpan gambar dan pindai kode QR dengan browser untuk melihatnya',
      VN: 'Vui lòng lưu ảnh và quét mã trong trình duyệt để xem',
      TH: 'โปรดบันทึกรูปภาพและสแกนโค้ดเพื่อดูในเบราว์เซอร์',
      PH: 'I-save ang image at i-scan ang code sa browser para i-view',
      BR: 'Por favor salve imagem e digitalize o código de navegador para vê-la',
    };
    return mapper[region] || 'Please save the image and scan the code in your browser to view';
  }, [region]);

  useLayoutEffect(() => {
    if (ref.current) {
      toJpeg(ref.current).then((dataURL) => {
        resourceURLToFile(dataURL).then((value) => {
          sendFileImage(value).then(() => {
            onSend();
          });
        });
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="absolute -top-96 -left-96">
      <div className="w-60 h-72 bg-fill-0 p-4 flex flex-col items-center" ref={ref}>
        <QRCodeSVG value={href} size={208} />
        <div className="w-52 mt-4 text-sm text-content-400">{text}</div>
      </div>
    </div>
  );
};
